import { FieldBase } from '@shared/components/dynamic-form/models/field-base';

export class FieldRichTextEditor extends FieldBase<string> {
  override controlType = 'rich-text-editor';
}
